import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailGroupService } from '../services/email-group.service';
import { EmailGroup } from '../models/email-group.model';
import { DialogService } from '../services/dialog.service';

export interface DialogData {
  group: EmailGroup
}
@Component({
  selector: 'app-delete-user-email-group',
  templateUrl: './delete-user-email-group.component.html',
  styleUrls: ['./delete-user-email-group.component.scss']
})
export class DeleteUserEmailGroupComponent implements OnInit {

  loading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<DeleteUserEmailGroupComponent>,
    private _emailGroupService: EmailGroupService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,public dialog: DialogService,
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close(false);
  }

  deleteGroup() {
    this.loading = true;
    this._emailGroupService.deleteGroup(this.data.group.id).subscribe(()=> {
      this.loading = false;
      this.dialogRef.close(true);
    }, (error) => {
      console.log(error);
      let data = error.error?.error ? error.error?.error : (error.error?.detail ? error.error?.detail : (error.error?.details ? error.error?.details : ``))
      this.dialog.UserUploadPopupConfirmPopup(data).subscribe(changed => {
      });
      this.dialogRef.close(true);
      //alert("An error ocurred while deleting the group. Check your connections and try again");
    });
  }

}
